import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { TelephonyComponentsModule } from '../../../telephony-components.module';
import { CustomerInformationComponent } from './customer-information.component';
import { CustomerDetailComponent } from './components/customer-detail.component';
import { CustomerActivityComponent } from './components/customer-activity.component';
import { CustomerCallStatsComponent } from './components/customer-call-stats.component';
import { CustomerOrdersFilterComponent } from './components/customer-orders-filter.component';
import { CustomerUsersInfoComponent } from './components/customer-users-info.component';
import { NgxJsonViewerModule } from '../../../modules/json-viewer/ngx-json-viewer.module';
import { ImpersonateOrganisationModule } from '../../impersonate-organisation/impersonate-organisation.module';

const routes: Routes = [
  { path: '', component: CustomerInformationComponent, data: { title: 'Customer Information' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerInformationRoutingModule {}

@NgModule({
  imports: [
    CustomerInformationRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TelephonyComponentsModule,
    NgxJsonViewerModule,
    ImpersonateOrganisationModule,
  ],
  declarations: [
    CustomerInformationComponent,
    CustomerDetailComponent,
    CustomerActivityComponent,
    CustomerCallStatsComponent,
    CustomerOrdersFilterComponent,
    CustomerUsersInfoComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CustomerInformationComponent,
    CustomerDetailComponent,
    CustomerActivityComponent,
    CustomerCallStatsComponent,
    CustomerOrdersFilterComponent,
    CustomerUsersInfoComponent,
  ],
})
export class CustomerInformationModule {}
